import { render } from "./side-nav-menu.vue?vue&type=template&id=4e6f1fc2"
import script from "./side-nav-menu.vue?vue&type=script&lang=js"
export * from "./side-nav-menu.vue?vue&type=script&lang=js"

import "./side-nav-menu.vue?vue&type=style&index=0&id=4e6f1fc2&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/side-nav-menu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4e6f1fc2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4e6f1fc2', __exports__)) {
    api.reload('4e6f1fc2', __exports__)
  }
  
  module.hot.accept("./side-nav-menu.vue?vue&type=template&id=4e6f1fc2", () => {
    api.rerender('4e6f1fc2', render)
  })

}


export default __exports__